import { prepararLiberacaoImagem } from "./prontuario-history-readings";
const positive = value => /^[1-9]\d*$/.test(String(value));
export const contextoAcaoHistorico = vm => JSON.stringify([vm.$route.fullPath, vm.$route.params.id, vm.atendimento.TIPO, vm.atendimento.ID, vm.atendimento.ID_ATENDIMENTO]);
const controllers = new WeakMap();
export async function requisitarAcaoHistorico(api, jwt, { consultar = false, dados }) {
  if(!jwt.getToken()) { throw Object.assign(new Error("Sessão indisponível."), { antesDoEnvio: true }); }
  api.setHeader();
  const { data } = await api.postOnce("atendimentos/access/" + (consultar ? "consultarAcaoHistorico" : "acaoHistoricoConfirmada"), dados, { timeout: 120000 });
  return data;
}
export function acaoHistoricoConfirmada(response, req) {
  return response?.contrato === "ACAO_HISTORICO_V1" && response.resultado === true && response.estado === "CONFIRMADO" &&
    ["ID_CLIENT_REQUEST", "ACAO", "TIPO", "ID_ITEM", "ID_PACIENTE", "ID_ATENDIMENTO", "ID_ATENDIMENTO_AUDITORIA", "ID_ATENDIMENTO_AREA", "ID_AGENDA_EXAME", "OPCAO_LIBERAR", "TITULO", "TITULO_ANTERIOR"]
      .every(field => req[field] == null || String(response[field]) === String(req[field]));
}
export function acoesHistorico(vm, requestId) {
  if(controllers.has(vm)) { return controllers.get(vm); }
  let pending = null, busy = false, closed = false, generation = 0, preparation = null;
  const valid = req => !closed && req.generation === generation && req.context === contextoAcaoHistorico(vm);
  const state = mensagem => { vm.acaoHistorico = { ocupada: busy, pendente: !!pending, mensagem }; };
  async function send(req, consultar) {
    busy = true; state(consultar ? "Consultando resultado…" : "Confirmando alteração…");
    try {
      let response;
      try { response = await vm.requisitarAcaoHistorico({ consultar, dados: req.payload }); }
      catch(error) {
        if(error.antesDoEnvio && !consultar) { if(valid(req)) { pending = null; state(error.message); } return false; }
      }
      if(!valid(req)) { return false; }
      if(!consultar && response?.estado === "REJEITADO" && acaoHistoricoConfirmada({ ...response, resultado: true, estado: "CONFIRMADO" }, req.payload)) {
        pending = null; state(response.mensagem || "Confira os dados antes de tentar novamente."); return false;
      }
      if(!consultar && !acaoHistoricoConfirmada(response, req.payload)) {
        try { response = await vm.requisitarAcaoHistorico({ consultar: true, dados: req.payload }); } catch(error) { /* Preservar para consulta. */ }
      }
      if(!valid(req)) { return false; }
      if(!acaoHistoricoConfirmada(response, req.payload)) {
        state("Resultado ainda não confirmado. Consulte antes de repetir a ação."); return false;
      }
      pending = null; state("");
      vm.$emit("acaoHistoricoConfirmada", { ...req.payload, DATA: req.data, ROTA: vm.$route.fullPath });
      const avisos = Array.isArray(response.AVISOS) ? response.AVISOS : [];
      vm.$swal({ icon: avisos.length ? "warning" : "success", title: "Alteração confirmada", text: [{
        AREA: "A área foi alterada com sucesso.", AUDITORIA: "A auditoria foi removida com sucesso.", IMAGEM: "A imagem foi excluída com sucesso.", DOCUMENTO: "O documento foi excluído com sucesso.", LIBERAR_IMAGEM: "Imagem liberada com sucesso.", TITULO_IMAGEM: "O título da imagem foi alterado com sucesso."
      }[req.payload.ACAO], ...avisos].join(" "), timer: avisos.length ? undefined : 3000 });
      return true;
    } finally { if(req.generation === generation) { busy = false; } if(valid(req)) { vm.acaoHistorico.ocupada = false; } }
  }
  async function executar(action) {
    if(closed || busy || vm.isLoading) { return false; }
    if(pending) { return valid(pending) ? send(pending, true) : false; }
    const row = JSON.parse(JSON.stringify(vm.atendimento));
    const req = { generation, context: contextoAcaoHistorico(vm), data: String(row.DATA_INCLUSAO || row.DATA || "").slice(0, 10), payload: {
      ID_CLIENT_REQUEST: requestId(), ACAO: action, TIPO: row.TIPO, ID_ITEM: row.ID,
      ID_PACIENTE: row.ID_PACIENTE || vm.$route.params.id
    } };
    if(!positive(req.payload.ID_ITEM) || !positive(req.payload.ID_PACIENTE) ||
      String(req.payload.ID_PACIENTE) !== String(vm.$route.params.id)) { state("Não foi possível identificar o registro. Atualize o histórico."); return false; }
    busy = true; state("");
    try {
      if(action === "LIBERAR_IMAGEM") {
        if(row.TIPO !== "IMAGEM" || row.DATA_EXCLUSAO) { state("A imagem não está disponível para liberação."); return false; }
        preparation = new AbortController();
        state("Carregando opções de liberação…");
        const options = await prepararLiberacaoImagem(vm, row, () => valid(req), preparation.signal);
        if(!valid(req) || !options) { if(valid(req)) { state(""); } return false; }
        Object.assign(req.payload, options);
      } else if(action === "TITULO_IMAGEM") {
        if(row.TIPO !== "IMAGEM" || row.DATA_EXCLUSAO) { state("A imagem não está disponível para alteração."); return false; }
        if(typeof row.TITULO_IMAGEM !== "string") { state("Atualize o histórico para carregar o título da imagem antes de alterá-lo."); return false; }
        const choice = await vm.$swal({ title: "Qual o título desejado?", input: "text", inputValue: row.TITULO_IMAGEM, showCancelButton: true,
          inputValidator: value => !String(value || "").trim() ? "Você precisa indicar o título!" : undefined });
        if(!valid(req) || !choice.isConfirmed || !String(choice.value || "").trim()) { return false; }
        req.payload.TITULO = String(choice.value).trim();
        req.payload.TITULO_ANTERIOR = row.TITULO_IMAGEM;
      } else if(action === "AREA") {
        const options = Object.fromEntries(vm.retornaAreasAtendimento().map(area => [area.value, area.text]));
        const choice = await vm.$swal({ title: "Selecione a área desejada:", input: "select", inputOptions: options,
          inputPlaceholder: "Selecione a área", showCancelButton: true, inputValidator: value => !positive(value) ? "Você precisa selecionar a área!" : undefined });
        if(!valid(req) || !choice.isConfirmed || !positive(choice.value)) { return false; }
        req.payload.ID_ATENDIMENTO_AREA = choice.value;
      } else if(action === "DOCUMENTO") {
        if(!["DOCUMENTO", "RECEITUARIO"].includes(row.TIPO) || row.PODE_EXCLUIR_DOCUMENTO !== true || row.DATA_EXCLUSAO) { return false; }
        const choice = await vm.$swal({ icon: "question", title: "Deseja realmente excluir o documento?", text: "Esta ação não poderá ser desfeita!",
          showCancelButton: true, cancelButtonText: "Cancelar", confirmButtonText: "Sim, desejo excluir", confirmButtonColor: "#d33" });
        if(!valid(req) || !choice.isConfirmed) { return false; }
      } else if(action === "IMAGEM") {
        if(row.TIPO !== "IMAGEM") { return false; }
        const choice = await vm.$swal({ icon: "question", title: "Deseja realmente excluir a imagem?", text: "Esta ação não poderá ser desfeita!",
          showCancelButton: true, cancelButtonText: "Cancelar", confirmButtonText: "Sim, desejo excluir", confirmButtonColor: "#d33" });
        if(!valid(req) || !choice.isConfirmed) { return false; }
        const reason = await vm.$swal({ title: "Informe o motivo da exclusão:", input: "text", showCancelButton: true,
          inputValidator: value => !String(value || "").trim() ? "Você precisa digitar o motivo!" : undefined });
        if(!valid(req) || !reason.isConfirmed || !String(reason.value || "").trim()) { return false; }
        req.payload.MOTIVO = String(reason.value).trim();
      } else if(action === "AUDITORIA") {
        req.payload.ID_ATENDIMENTO = row.ID_ATENDIMENTO;
        req.payload.ID_ATENDIMENTO_AUDITORIA = row.AUDITORIA?.ID_ATENDIMENTO_AUDITORIA;
        if(!positive(req.payload.ID_ATENDIMENTO) || !positive(req.payload.ID_ATENDIMENTO_AUDITORIA)) { state("Atualize o histórico para identificar a auditoria."); return false; }
      } else { return false; }
      if(!valid(req)) { return false; }
      pending = req;
      return await send(req, false);
    } catch(error) { if(valid(req)) { state(pending ? "Não foi possível concluir a ação. Confira o resultado antes de continuar." : "Não foi possível preparar a ação. Confira os dados e tente novamente."); } return false; }
    finally { if(req.generation === generation) { busy = false; } if(valid(req)) { vm.acaoHistorico.ocupada = false; } }
  }
  const controller = { executar, consultar: () => pending && valid(pending) && !busy ? send(pending, true) : Promise.resolve(false),
    invalidar() { generation++; preparation?.abort(); pending = null; busy = false; state(""); },
    destruir() { preparation?.abort(); closed = true; } };
  controllers.set(vm, controller); return controller;
}
